import React, { useEffect } from "react";
import "./ContextMenu.css"; 

const ContextMenu = ({ x, y, options, onClose }) => {
  useEffect(() => {
    const handleClick = () => onClose();
    document.addEventListener("click", handleClick);
    return () => document.removeEventListener("click", handleClick);
  }, [onClose]);

  return (
    <ul
      className="context-menu"
      style={{ position: "absolute", top: y, left: x, zIndex: 1000 }}
    >
      {options.map((option, index) => (
        <li
          key={index}
          className={option.dangerous ? "dangerous" : ""}
          onClick={(e) => {
            // Handle both onClick and action properties for backward compatibility
            const handler = option.onClick || option.action;
            if (typeof handler === 'function') {
              handler(e);
            } else {
              console.warn('Menu option has no valid handler:', option);
            }
            if (!option.keepOpen) {
              onClose();
            }
          }}
        >
          {option.divider && <hr className="context-menu-divider" />}
          {option.label}
        </li>
      ))}
    </ul>
  );
};

export default ContextMenu;
